import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";

const API = process.env.REACT_APP_API_BASE_URL;

export default function TambahAdminPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });

  const [photo, setPhoto] = useState<File | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handlePhoto = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setPhoto(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const token = Cookies.get("token");

    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("phone", form.phone);
    formData.append("password", form.password);

    if (photo) {
      formData.append("photo", photo);
    }

    try {
      await axios.post(`${API}/api/register-admin`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire("Berhasil", "Admin berhasil ditambahkan", "success");

      navigate("/dashboard/admin");
    } catch (error) {
      Swal.fire("Error", "Gagal menambahkan admin", "error");
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
      {/* TITLE */}
      <Link to="/dashboard/admin" className="flex items-center gap-2 mb-6">
        <IoMdArrowBack />
        <h2 className="text-xl font-bold">Tambah Admin</h2>
      </Link>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-xl shadow space-y-4">
        {/* NAME */}
        <div>
          <label className="text-sm font-medium">Nama</label>
          <input type="text" name="name" required value={form.name} onChange={handleChange} className="w-full border rounded-lg p-2 mt-1" />
        </div>

        {/* EMAIL */}
        <div>
          <label className="text-sm font-medium">Email</label>
          <input type="email" name="email" required value={form.email} onChange={handleChange} className="w-full border rounded-lg p-2 mt-1" />
        </div>

        {/* PHONE */}
        <div>
          <label className="text-sm font-medium">Phone</label>
          <input type="text" name="phone" required value={form.phone} onChange={handleChange} className="w-full border rounded-lg p-2 mt-1" />
        </div>

        {/* PASSWORD */}
        <div>
          <label className="text-sm font-medium">Password</label>
          <input type="password" name="password" required value={form.password} onChange={handleChange} className="w-full border rounded-lg p-2 mt-1" />
        </div>

        {/* PHOTO */}
        <div>
          <label className="text-sm font-medium">Photo</label>
          <input type="file" accept="image/*" onChange={handlePhoto} className="w-full border rounded-lg p-2 mt-1" />
        </div>

        {/* BUTTON */}
        <div className="flex gap-3 pt-4">
          <button type="submit" className="bg-primary text-white px-6 py-2 rounded-lg hover:opacity-90">
            Simpan
          </button>

          <button type="button" onClick={() => navigate("/dashboard/admin")} className="bg-gray-200 px-6 py-2 rounded-lg">
            Batal
          </button>
        </div>
      </form>
    </div>
  );
}
